import styled, { css } from 'styled-components/macro';

export const QrContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: max-content;
  padding: 24px 12px 12px;
  border-radius: 12px;

  ${({ theme }) => css`
    box-shadow: 0 1px 2px 0 ${theme.colors.gray['200']};
    border: 1px solid ${theme.colors.gray['100']};
    background-color: ${theme.colors.white};
    box-shadow: 0 1px 2px 0 ${theme.colors.gray['200']};
    transition: background-color 150ms, border-color 150ms;
  `}
`;

export const QrCode = styled.img`
  width: 192;
  height: 192px;
`;

export const StoreBadge = styled.img`
  height: auto;
`;
